import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import MarketingSite from "./MarketingSite";
import "./marketing-v2.css";
import "./blog.css";
import "./modern.css";
import "./cookie-consent.css";

const application = (
  <StrictMode><BrowserRouter><MarketingSite /></BrowserRouter></StrictMode>
);
const root = document.getElementById("root")!;
if (root.dataset.prerendered === "true") hydrateRoot(root, application);
else createRoot(root).render(application);
